import { render, staticRenderFns } from "./CompBPModal.vue?vue&type=template&id=e1604484"
import script from "./CompBPModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CompBPModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports